var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10435 3.11378L7.3959 1.79112C7.17546 1.57067 6.67946 1.46045 6.34879 1.46045H4.25457C3.59323 1.46045 2.87679 1.95645 2.71146 2.61778L1.38879 6.64089C1.11323 7.41245 1.60923 8.07378 2.4359 8.07378H4.64035C4.97101 8.07378 5.24657 8.34934 5.19146 8.73512L4.9159 10.4987C4.80568 10.9947 5.13635 11.5458 5.63235 11.7111C6.07324 11.8764 6.62435 11.656 6.84479 11.3253L9.10435 7.96356",
    stroke: "black",
    strokeWidth: 0.826667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.915 3.11376V8.51465C11.915 9.28621 11.5843 9.56176 10.8128 9.56176H10.2616C9.49009 9.56176 9.15942 9.28621 9.15942 8.51465V3.11376C9.15942 2.34221 9.49009 2.06665 10.2616 2.06665H10.8128C11.5843 2.06665 11.915 2.34221 11.915 3.11376Z",
    stroke: "black",
    strokeWidth: 0.826667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.8a2ba4ad9c2eeba2f34e16c728adc4f0.svg";
export { ForwardRef as ReactComponent };